module.exports = __webpack_public_path__ + "static/img/tile-1.f162568.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tile-1.jpeg
// module id = 148
// module chunks = 180